import { ProfileMenu, TopBar, TopBarDivider, TopBarSwitcher } from '@ka/webcomponents/nav';
import { useUser } from '../../userAccess/useUser';
import { SiteUserRole, UserSite } from '../../userAccess/UserContext';
import { LoadPassLogo } from '../../common/LoadPassLogo';

export function AdminTopBar() {
  const user = useUser();

  return (
    <TopBar brand={<LoadPassLogo to="/admin" />}>
      <TopBarSwitcher
        heading="Site"
        placeholder="Select Site"
        selected={user.selectedSite}
        options={user.userSites}
        toOption={toOption}
        onSelect={user.setSelectedSite} />
      <TopBarDivider />
      <ProfileMenu
        email={user.email}
        onSignOut={() => user.signOut()}
        badges={user.selectedSite && <span className="badge bg-soft-primary text-primary">{roleNames[user.selectedSite.role]}</span>} />
    </TopBar>
  );
}

const roleNames: Record<SiteUserRole, string> = {
  [SiteUserRole.Admin]: 'Admin',
  [SiteUserRole.LimitedAccess]: 'Limited Access',
};

const toOption = (site: UserSite) => ({
  id: site.id,
  name: `${site.city}, ${site.state}`,
  description: `(${site.business})`,
});
